import type { CtaType } from '@repo/supergraph/marketplace/types';

export const stripFederallyInsuredAnnotation = (
  cta?: CtaType | null,
  federallyInsuredAnnotation?: string,
) => {
  if (!cta || !cta.subtext || !federallyInsuredAnnotation) return cta;

  const annotationPattern = `, ${federallyInsuredAnnotation}`;
  if (cta.subtext.endsWith(annotationPattern)) {
    return {
      ...cta,
      subtext: cta.subtext.slice(0, -annotationPattern.length),
    };
  }

  return cta;
};
